import {AppController} from "../app/app-controller";
import {ActionHandler} from "../../infrastructure/handlers/action-handler";
import {APP} from "../app/consts";
import {FetchHandler} from "../../infrastructure/handlers/fetch-handler";
import {UsersRequestParams} from "../../domain/users/models/users.request-params";
import {UsersFetchModel} from "../../domain/users/models/users.fetch-model";
import {UsersDeviceModel} from "../../domain/users/models/users.device-model";
import {UsersSelectionsModel} from "../../domain/users/models/users.selections-model";
import {UsersDomainService} from "../../domain/users/services/users.domain-service";
import {LOCAL_STORAGE_KEYS} from "../consts";
import {UserSelectionsManager} from "../managers/user-selections.manager";
import {UsersNotificationsModel} from "../../domain/users/models/users.notifications-model";
import {SelectionEntityModel} from "../../infrastructure/models/selection-entity.model";
import {LocalStorageUtils} from "../../infrastructure/utils/local-storage.utils";
import {SiteConfig} from "../bootstrap/models/site-config";
import {debounce} from "../../infrastructure/debounce/debounce";
import {singleton} from "../../infrastructure/decorators/singleton";

@singleton
export class UsersFetchHandler extends FetchHandler {
  type = APP.ACTION_TYPES.fetchUsers;
  controller: AppController;

  static injectables = [...ActionHandler.injectables, UsersDomainService, LocalStorageUtils, UserSelectionsManager, SiteConfig];

  constructor(usersDomainService: UsersDomainService, localStorageUtils: LocalStorageUtils, userSelectionsManager: UserSelectionsManager, siteConfig: SiteConfig) {
    super(usersDomainService);

    this.localStorageUtils = localStorageUtils;
    this.userSelectionsManager = userSelectionsManager;
    this.siteConfig = siteConfig;
    this.debounceFunction = debounce(this.fetch, 1000);
    this.userSelectionsManager.registerToActions("UsersFetchHandler", () => this.action());
  }

  get requestParams(): UsersRequestParams {
    const visitorId: String = this.localStorageUtils.get(LOCAL_STORAGE_KEYS.visitorId);
    const token: String = this.appStore.state.userPushNotificationsSubscription;
    const userCountryId: Number = this.appStore.state.locale.userCountryId;
    const languageId: Number = this.appStore.state.locale.language.id;
    const enableNotifications: Boolean = this.appStore.state.userAllowedNotification && this.appStore.state.enableNotifications;
    const usersDeviceModel: UsersDeviceModel = new UsersDeviceModel(visitorId, token);
    const usersSelectionsModel: UsersSelectionsModel = new UsersSelectionsModel(this.userSelectionsManager.competitorsIds, this.userSelectionsManager.gamesIds, this.userSelectionsManager.competitionsIds);
    const notifications: Array<UsersNotificationsModel> = this.userSelectionsManager.userSelections.map((selection: SelectionEntityModel) => new UsersNotificationsModel(selection.id, selection.type));

    const fetchModel: UsersFetchModel = new UsersFetchModel(userCountryId, languageId, enableNotifications, usersDeviceModel, usersSelectionsModel, notifications);
    const isQA: Boolean = this.siteConfig.apiType.includes('qa');
    const requestParams: UsersRequestParams = new UsersRequestParams(fetchModel, isQA);

    return requestParams;
  }

  async action() {
    this.debounceFunction();
  }
}
